// Sharp 1px-bordered status badges. No rounded corners.
const VARIANTS = {
  applied: { label: "Applied", color: "border-quiet text-quiet bg-white" },
  screened: { label: "AI Screened", color: "border-info text-info bg-white" },
  round1_scheduled: { label: "R1 Scheduled", color: "border-info text-info bg-white" },
  round1_feedback: { label: "R1 Feedback", color: "border-info text-ink bg-paper" },
  round1_rejected: { label: "Rejected R1", color: "border-error text-error bg-white" },
  round2_scheduled: { label: "R2 Scheduled", color: "border-warning text-warning bg-white" },
  round2_feedback: { label: "R2 Feedback", color: "border-warning text-ink bg-paper" },
  round2_rejected: { label: "Rejected R2", color: "border-error text-error bg-white" },
  final_scheduled: { label: "Final Scheduled", color: "border-klein text-klein bg-white" },
  final_feedback: { label: "Final Feedback", color: "border-klein text-ink bg-paper" },
  final_rejected: { label: "Rejected Final", color: "border-error text-error bg-white" },
  selected: { label: "Selected", color: "border-success text-success bg-white" },
  pending_review: { label: "Pending HR Review", color: "border-warning text-warning bg-white" },
  open: { label: "Open", color: "border-success text-success bg-white" },
  rejected: { label: "Rejected", color: "border-error text-error bg-white" },
  closed: { label: "Closed", color: "border-quiet text-quiet bg-white" },
};

export default function StatusBadge({ status, testId }) {
  const v = VARIANTS[status] || { label: status, color: "border-quiet text-quiet bg-white" };
  // Map runtime tailwind classes by mapping color tokens
  const colorMap = {
    "border-quiet text-quiet bg-white": "border-[#9CA3AF] text-[#52525B] bg-white",
    "border-info text-info bg-white": "border-[#3B82F6] text-[#3B82F6] bg-white",
    "border-warning text-warning bg-white": "border-[#F59E0B] text-[#F59E0B] bg-white",
    "border-warning text-ink bg-paper": "border-[#F59E0B] text-[#0F0F0F] bg-[#F7F7F5]",
    "border-error text-error bg-white": "border-[#EF4444] text-[#EF4444] bg-white",
    "border-klein text-klein bg-white": "border-[#002FA7] text-[#002FA7] bg-white",
    "border-klein text-ink bg-paper": "border-[#002FA7] text-[#0F0F0F] bg-[#F7F7F5]",
    "border-success text-success bg-white": "border-[#10B981] text-[#10B981] bg-white",
  };
  const cls = colorMap[v.color] || "border-[#D2D2D0] text-[#52525B] bg-white";
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center px-2 py-1 border text-[10px] font-mono uppercase tracking-[0.15em] ${cls}`}
    >
      {v.label}
    </span>
  );
}
